<template>
  <div>
    <div id="clouds">
      <div class="cloud x1"></div>
      <div class="cloud x1_5"></div>
      <div class="cloud x2"></div>
      <div class="cloud x3"></div>
      <div class="cloud x4"></div>
      <div class="cloud x5"></div>
    </div>

    <div class="center-item">
    <h1 class="text-uppercase text-danger">404 | Pagina no encontrada</h1>
    <br />
    <router-link class="btn btn-primary btn-return text-uppercase text-white" to="/">Ir Inicio</router-link>
    </div>

  </div>
</template>

<style scoped src="../assets/css/style-404-page.css"></style>